<template>
	<li v-if="hasCommercialAccess && !item.hidden" :class="{ 'nav-item': true, 'has-child': hasChild, 'menu-open': isOpen, 'menu-selected': isSelected, 'menu-focused': isFocused, 'nav-item-disabled': isDisabled }" :title="isDisabled ? 'دسترسی ندارید' : item.pageTitle">
		<div class="menu-root">
			<a @click="itemClicked()"><span class="icon">
					<icon :icon="item.icon" />
				</span> {{ item.pageTitle }}</a>
			<span v-if="hasChild" class="menu-state">
				<icon :icon="isOpen ? 'angle-left fal' : 'angle-down fal'" />
			</span>
		</div>
		<ul v-if="hasChild" v-show="hasChild && isOpen" class="menu-children" ref="childrenList">
			<nav-menu-item v-for="route of item.items" :key="route.id" :item="route" :selectedItem="selectedItem" :hasCommercialAccess="route.hasCommercialAccess" :isDisabled="route.isDisabled ? true : null" :focusedItem="focusedItem" :openedItem="openedItem" @menuClicked="childClicked" @openedItemChanged="openedItemChanged"></nav-menu-item>
		</ul>
	</li>
</template>
<script>
	export default {
		props: {
			item: { type: Object, required: true },
			selectedItem: { type: Object },
			focusedItem: { type: Object },
			openedItem: { type: Object },
			isDisabled: { type: Boolean },
			hasCommercialAccess: { type: Boolean, default: true },
		},
		emits: ['update:modelValue', 'openedItemChanged', 'menuClicked', ''],
		data() {
			return {}
		},
		computed: {
			hasChild() {
				return this.item && this.item.items && this.item.items.length > 0
			},
			isSelected() {
				return (
					this.selectedItem && this.item && this.selectedItem.id === this.item.id
				)
			},
			isFocused() {
				return (
					this.focusedItem && this.item && this.focusedItem.id === this.item.id
				)
			},
			isOpen() {
				let possible = this.openedItem && this.item
				let is = possible && this.openedItem.id === this.item.id
				if (possible && !is) {
					const isChild = (node) => {
						if (node.items && node.items.length > 0) {
							for (let n of node.items) {
								if (n.id === this.openedItem.id) {
									return true
								} else if (n.items && n.items.length > 0) {
									let found = isChild(n)
									if (found) {
										return true
									}
								}
							}
						}

						return false
					}

					is = isChild(this.item)
				}

				return is
			},
		},
		created() { },
		mounted() { },
		methods: {
			itemClicked() {
				if (this.isDisabled) return
				if (this.hasChild) {
					this.$emit('openedItemChanged', this.isOpen ? null : this.item)
					this.checkPosition()
				} else {
					this.$emit('openedItemChanged', null)
					this.$emit('menuClicked', this.item)
				}
			},
			childClicked(child) {
				this.$emit('menuClicked', child)
			},
			openedItemChanged(child) {
				this.$emit('openedItemChanged', child)
			},
			checkPosition() {
				if (!this.$refs.childrenList) return
				this.defer(() => {
					let boundingRect = this.$refs.childrenList.getBoundingClientRect()
					let view = this.$refs.childrenList.ownerDocument.defaultView
					let top = boundingRect.top + view.pageYOffset
					let height = boundingRect.height

					if (height > window.innerHeight) {
						this.$refs.childrenList.style.maxHeight = (window.innerHeight - 100) + 'px'
						this.$refs.childrenList.style.overflow = 'auto'
						height = this.$refs.childrenList.getBoundingClientRect().height
					}

					if (top + height > window.innerHeight) {
						this.$refs.childrenList.style.top = window.innerHeight - (top + height + 40) + 'px'
					}
				}, 0.1)
			}
		},
	}
</script>
<style>
	.nav-item-disabled a {
		cursor: not-allowed !important;
		color: #919191 !important;
	}

	.nav-item-disabled a::selection {
		background-color: transparent;
	}
</style>
